<app-modal [open]="active" [name]="'decline'" (close)="closeDialog()">
  <div modal-header>{{ multiple ? 'Decline All?' : title }}</div>
  <div modal-body>
    <ng-container *ngIf="multiple">
      <p class="decline-dialog__intro">
        You're about to decline <strong>{{ items.length }} products</strong>{{ scopeLabel ? ' ' + scopeLabel : '' }}.
      </p>
      <app-decline-item-list class="decline-dialog__items" [items]="items" itemTestId="decline-all-item" listLabel="Products to decline"></app-decline-item-list>
    </ng-container>
    <div class="form-field">
      <label class="form-label" for="decline-reason">Reason</label>
      <select
        name="reason"
        id="decline-reason"
        class="form-select"
        data-testid="decline-reason"
        (change)="selectReason($event)"
      >
        <option *ngFor="let reason of declineReasons" [value]="reason.value">
          {{ reason.label }}
        </option>
      </select>
    </div>
    <div class="form-field" *ngIf="reasonSelectedIndex === 5">
      <div class="decline-dialog__error">
        *Required (please give more information below)
      </div>
      <input
        type="text"
        class="input"
        placeholder="Reason"
        data-testid="decline-other-reason"
        [(ngModel)]="otherReason"
        [attr.maxlength]="maxCommentLength"
        (input)="checkOtherReason()"
      />
      <span class="decline-dialog__char-count">{{ otherReason.length }} / {{ maxCommentLength }}</span>
    </div>
    <div class="form-field">
      <textarea
        class="input decline-dialog__notes"
        id="decline-comments"
        placeholder="Comments"
        data-testid="decline-comments"
        [(ngModel)]="comments"
        [attr.maxlength]="maxCommentLength"
      ></textarea>
      <span class="decline-dialog__char-count">{{ comments.length }} / {{ maxCommentLength }}</span>
    </div>
    <div
      class="decline-dialog__summary"
      *ngIf="
        !multiple && (siteType ||
        address?.streetAddress?.length > 0 ||
        address?.cityStateZip?.length > 0)
      "
    >
      <div class="decline-dialog__summary-item" *ngIf="siteType">
        <p class="decline-dialog__summary-label">Service Type</p>
        <p class="decline-dialog__summary-value">
          {{ siteSubType ? siteType + " - " + siteSubType : siteType }}
        </p>
      </div>
      <div
        class="decline-dialog__summary-item"
        *ngIf="
          address?.streetAddress?.length > 0 || address?.cityStateZip?.length > 0
        "
      >
        <p class="decline-dialog__summary-label">Location</p>
        <p class="decline-dialog__summary-value">
          <span *ngIf="address?.streetAddress"
            >{{ address?.streetAddress }}<br
          /></span>
          {{ address?.cityStateZip }}
        </p>
      </div>
    </div>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--danger"
    data-testid="decline-confirm"
    [disabled]="isDisabled"
    (click)="declineInvitation()"
  >
    {{ multiple ? 'Decline All' : 'Decline' }}
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="decline-cancel"
    (click)="closeDialog()"
  >
    Cancel
  </button>
</app-modal>
